import { isValidEmail } from "@teaming/common-ui/utils";

export default function( { i18n, } ) {
	return [
		{
			field: "name",
			rule: ( { name, } ) => {
				if ( name.value.trim().length === 0 ) {
					return { message: i18n.global.t( "validation.team_validation_teamName" ), };
				}
			},
		},
		{
			field: "memberBeingAdded",
			rule: ( { memberBeingAdded, members, } ) => {
				if ( memberBeingAdded.value.length !== 0 && !isValidEmail( memberBeingAdded.value ) ) {
					return { message: i18n.global.t( "validation.team_validation_memberBeingAdded" ), };
				}

				const memberEmails = members.value.map( teamMember => teamMember.email );
				if ( memberEmails.includes( memberBeingAdded.value ) ) {
					return { message: i18n.global.t( "validation.team_validation_duplicateMemberBeingAdded" ), };
				}
			},
		},
	];
}
